export default __webpack_public_path__ + "static/portfolio-about-097c41cabfce3f63d030d9be678105a6.jpg";